import * as React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "../../../../constants/fontAwesomeIcons";

import './NotificationAlert.scss';


export interface INotificationAlertProps {
    alertContent: React.ReactNode;
    icon?: any;
    className?: string;
    maxWidth?: number;
    minWidth?: number;
}

class NotificationAlert extends React.Component<INotificationAlertProps, any> {
    override render() {
        const {
            alertContent,
            icon,
            className,
            maxWidth,
            minWidth
        } = this.props;

        const derivedMaxWidth = maxWidth ? maxWidth : 500;
        const derivedMinWidth = minWidth ? minWidth : 500

        return (
            <div style={{maxWidth: derivedMaxWidth, minWidth: derivedMinWidth}} className={classNames("container alert-container", className )}>
                <div className="row">
                    {
                        icon ?
                            <div className="col-3 alert-icon">
                                <FontAwesomeIcon icon={icon} size="3x" fixedWidth/>
                            </div> :
                            null
                    }
                    {
                        alertContent ?
                            <div className="col-9 alert-content p-6">
                                {alertContent}
                            </div> :
                            null
                    }
                </div>
            </div>
        );
    }
}

export default NotificationAlert;
